module.exports = __webpack_public_path__ + "4be97b67337daff36a2fbb72f4cb0799.png";